import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import { Spinner } from '@breezeway/brzw-components';

import './empty_section.scss';

const EmptySection = ({
  actionButton,
  actionMessage,
  children,
  emptyMessage,
  isEmpty,
  isLoading,
  onActionClick,
  withAction,
}) => {
  const renderWrapper = child => <div className="empty-section">{child}</div>;
  const renderEmpty = (
    <Fragment>
      <span className="empty-section__message">{emptyMessage}</span>

      {withAction && actionMessage && (
        <Button color="link" className="empty-section__link py-0" onClick={onActionClick}>
          {actionMessage}
        </Button>
      )}
      {withAction && actionButton && actionButton}
    </Fragment>
  );
  const renderLoading = renderWrapper(
    <div className="empty-section__loading-wrapper">
      <Spinner size="large" />
    </div>,
  );

  if (isEmpty && !isLoading) return renderWrapper(renderEmpty);
  else if (isEmpty && isLoading) return renderWrapper(renderLoading);
  return renderWrapper(children);
};

EmptySection.propTypes = {
  actionButton: PropTypes.node,
  actionMessage: PropTypes.string,
  children: PropTypes.node,
  emptyMessage: PropTypes.string,
  isEmpty: PropTypes.bool,
  onActionClick: PropTypes.func,
  withAction: PropTypes.bool,
};

EmptySection.defaultProps = {
  actionButton: null,
  children: null,
  emptyMessage: '',
  isEmpty: false,
  onActionClick: () => {},
  withAction: true,
};

export default EmptySection;
